export { default } from './ResponsivePagination'
